<div
  [ngClass]="disableStepper ? '' : 'button-wrapper'"
  (mouseover)="mouseOver()"
  (mouseleave)="mouseLeave()"
>
  <button
    *ngIf="!localLoading; else loader"
    (click)="onClick(index)"
    class="step mat-body inactive"
    [class.custom]="isCustomStep"
    [class.non-interactive]="!clickable"
    [class.not-completed]="!completed || disableStepper"
    [ngStyle]="{
      background: (completed || hovering) && customColor ? customColor : undefined,
      color: (completed || hovering) ? undefined : 'white'
    }"
    [matTooltip]="(completed && !!step.state?.createdDate) ?
      showTooltip ?
      step.state?.inactiveLabel + '\n' + step.state?.createdDate :
      step.state?.createdDate : step.state?.inactiveLabel"
    matTooltipPosition="above"
    [attr.data-cy]="'inactive-step-button-' + index"
  >
    <ng-container *ngIf="!isCustomStep; else customStep">
      <ng-container *ngIf="showLabel">
        <mat-icon
          color="primary"
          class="md arrow-icon"
          *ngIf="hovering && clickable"
        >keyboard_arrow_right</mat-icon>
        {{hovering ? stepLabel : ''}}
      </ng-container>
    </ng-container>
  </button>
</div>

<ng-template #loader>
  <mat-spinner
    color="primary"
    [diameter]="16"
    [strokeWidth]="2"
  ></mat-spinner>
</ng-template>
<ng-template #customStep>
  <div
    class="custom-template"
    [class.show-on-hover]="hovering"
  >
    <ng-container
      *ngTemplateOutlet="step.stepLabel.template; context: tplContext"
    >
    </ng-container>
  </div>
</ng-template>
